module.exports = __webpack_public_path__ + "media/images/banners/main-7cee923890fc46903de1461549437103.jpg";